import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { IRaffle } from "../../../store/interfaces/IRaffle";
import { useEffect } from "react";
import { BadgeCheck } from "lucide-react";
import { useIsMobileView } from "../../../utils/responsive";

interface RaffleSelectorProps {
  selectedRaffleId: string;
  handleSelectRaffle: (e: IRaffle) => void;
  rafflesFounded: IRaffle[];
  setSelectedRaffleId?: (e: string) => void;
  setSelectedRaffleLimit?: (e: number) => void;
}

export const RaffleSelector = ({
  selectedRaffleId,
  handleSelectRaffle,
  rafflesFounded,
  setSelectedRaffleId,
  setSelectedRaffleLimit,
}: RaffleSelectorProps) => {
  useEffect(() => {
    if (rafflesFounded && rafflesFounded.length > 0) {
      for (const raffle of rafflesFounded) {
        if (raffle.status === "ACTIVE") {
          handleSelectRaffle(raffle);
          setSelectedRaffleId?.(raffle.id);
          setSelectedRaffleLimit?.(raffle.limit);
          break;
        }
      }
    }
  }, [rafflesFounded]);

  const sortedRaffles = [...rafflesFounded].sort((a, b) =>
    new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
  );

  const isMobile = useIsMobileView();

  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel id="raffle-select-label">Seleccionar rifa</InputLabel>
      <Select
        size="small"
        labelId="raffle-select-label"
        id="raffle-select"
        value={selectedRaffleId}
        label="Seleccionar rifa"
      >
        {sortedRaffles.map((raffle) => (
          <MenuItem
            key={raffle.id}
            value={raffle.id}
            onClick={() => {
              handleSelectRaffle(raffle);
              setSelectedRaffleId?.(raffle.id);
              setSelectedRaffleLimit?.(raffle.limit);
            }}
          >
            <Typography paddingRight={2}>
              {raffle.name} {!isMobile && raffle.createdDate && `(${new Date(raffle.createdDate).toLocaleDateString()})`}
              {raffle.status === "ACTIVE" && (
                <Chip sx={{ marginLeft: 1 }} label="Activa" color="primary" /> 
              )}
              {raffle.isPremium && (
                <BadgeCheck color="blue" style={{ marginLeft: 2 }}></BadgeCheck>
              )}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
